export enum TransportJobStatus {
  PENDING = 'pending',
  /**
   * Accepted, but deliberately not offered to anyone yet.
   *
   * Held back while a batch it belongs to is waiting to be accepted. Labelled
   * for what it is rather than for why: which batch a job is in is a fact about
   * the job, shown in its own column, and burying it in the status column
   * displaced the thing the column is for.
   */
  HELD = 'held',
  ASSIGNED = 'assigned',
  /** Picked up, on its way. Set when the driver completes the collection stop. */
  COLLECTED = 'collected',
  COMPLETED = 'completed',
  REJECTED = 'rejected',
  UNFULFILLED = 'unfulfilled',
}

export const TransportJobStatusLabels: Record<TransportJobStatus, string> = {
  [TransportJobStatus.PENDING]: 'Pending',
  [TransportJobStatus.HELD]: 'Held',
  [TransportJobStatus.ASSIGNED]: 'Assigned',
  [TransportJobStatus.COLLECTED]: 'Collected',
  [TransportJobStatus.COMPLETED]: 'Completed',
  [TransportJobStatus.REJECTED]: 'Rejected',
  [TransportJobStatus.UNFULFILLED]: 'Unfulfilled',
};

export const TransportStatuses = [
  TransportJobStatus.PENDING,
  TransportJobStatus.HELD,
  TransportJobStatus.ASSIGNED,
  TransportJobStatus.COLLECTED,
  TransportJobStatus.COMPLETED,
  TransportJobStatus.REJECTED,
  TransportJobStatus.UNFULFILLED,
];
